// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const PublicNotes = ($window: any) => ({
   templateUrl: '/assets/publicNotes.html',
   controllerAs: 'vm',
   controller: PublicNotesController,

   bindToController: {
      doc: '<'
   }
})

class PublicNotesController {
   dbNotes: any
   doc: any
   isLoading: any
   isLocationNotesFeatureEnabled: any
   isPublicNotesFeatureEnabled: any
   publicNoteService: any
   constructor(publicNoteService: any, quickLookService: any) {
      this.$onInit = this.$onInit.bind(this)
      this.getPublicNotes = this.getPublicNotes.bind(this)
      this.mapToPublicNotesArray = this.mapToPublicNotesArray.bind(this)
      this.publicNoteService = publicNoteService
      this.isLoading = false
      this.dbNotes = []
      this.isPublicNotesFeatureEnabled = quickLookService.quickLookConfig.showPublicNotes
      this.isLocationNotesFeatureEnabled = quickLookService.quickLookConfig.showLocationNotes
   }

   $onInit() {
      return this.getPublicNotes()
   }

   $onChanges(changesObj: any) {
      if (changesObj.doc && !changesObj.doc.isFirstChange()) {
         return this.getPublicNotes()
      }
   }

   getPublicNotes() {
      this.isLoading = true
      return this.publicNoteService
         .getNotes(this.doc.iedl_dbids.join(), this.doc.ssids?.join())
         .then((response: any) => {
            this.isLoading = false
            return this.dbNotes = this.mapToPublicNotesArray(response.data)
         })
         .catch((e: any) => {
            this.isLoading = false
            return console.error(`PublicNotes: ${e.data.message}`)
         })
   }

   mapToPublicNotesArray(apiData: any) {
      const result = []
      const dbids = _.toArray(apiData)
      for (var dbid of dbids) {
         var dbNotes = {
            name: dbid.name,
            notes: []
         }
         if (this.isPublicNotesFeatureEnabled) {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            if (dbid.databaseNote) { dbNotes.notes.push(dbid.databaseNote) }
         }

         // there should only be 1 title per dbid -- take the first one
         var title = _.toArray(dbid.titles)[0]
         if (this.isPublicNotesFeatureEnabled) {
            // Title Note should override All Title Note
            if (title?.titleNote) {
               // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
               dbNotes.notes.push(title.titleNote)
            } else {
               // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
               if (dbid.allTitleNote) { dbNotes.notes.push(dbid.allTitleNote) }
            }
         }

         if (title?.titleLocationNote && this.isLocationNotesFeatureEnabled) {
            // @ts-expect-error TS(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
            dbNotes.notes.push(title.titleLocationNote)
         }

         if (dbNotes.notes.length) {
            dbNotes.notes = _.uniq(dbNotes.notes)
            result.push(dbNotes)
         }
      }

      return result
   }
}

PublicNotesController.$inject = ['publicNoteService', 'quickLookService']

angular.module('summonApp.directives')
   .controller('publicNotesController', PublicNotesController)
   .directive('publicNotes', ['$window', PublicNotes])
